<template>
    <!-- DESCR：会议论文提交描述页面 -->
    <div class="createpaper-container">
        <!-- 页面信息描述 -->
        <el-row justify="center" @click="fast">
            <el-col :span="21" class="login-title">
                <div class="desc-box">
                    <div class="title">{{ $route.query.acronym }} Submission {{ $route.query.subnum }}</div>
                    <br />
                    <div class="info">
                        This page is for conference paper submission. Please fill in the corresponding paper submission
                        information
                    </div>
                    <div class="info">
                        At the same time, you need to upload a PDF file and fill in the author information list
                        of the paper
                    </div>
                    <div class="info">After filling in the information and submitting it, the chairman will receive your
                        paper and decide whether to push it to other reviewers
                    </div>
                </div>
            </el-col>
            <el-col :span="3" class="login-title" style="display: flex;align-items: center;justify-content: center;"
                size="small" @click="$router.back()">
                <el-button type="primary" :icon="ArrowLeftBold" circle plain></el-button>
            </el-col>
        </el-row>
        <el-row :gutter="10" justify="center">
            <el-col :span="18">
                <el-form :model="paperform" ref="ruleForm" class="paperinput-box">
                    <el-form-item label="Title:" prop="title"
                        :rules="[{ required: true, message: 'title Cannot be empty' }]">
                        <el-input v-model="paperform.title" style="width:700px"></el-input>
                    </el-form-item>
                    <el-form-item label="Paper:" prop="authorkeywords"
                        :rules="[{ required: true, message: 'file Cannot be empty' }]">
                        <el-upload class="upload-demo" drag :auto-upload="false" :http-request="createpaper"
                            style="width:700px" ref="myfile" v-model:file-list="fileList" :limit="1"
                            :on-exceed="handleExceed" accept=".pdf">
                            <el-icon style="font-size:35px">
                                <document />
                            </el-icon>
                            <div class="el-upload__text">
                                <span v-if="fileList.length == 0">Drag the PDF file here，or <em>click upload</em></span>
                                <span v-else>Successfully uploaded. If there are any modifications, you can<em> reupload
                                        PDF
                                        file</em></span>
                            </div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="Author keywords:" prop="authorkeywords"
                        :rules="[{ required: true, message: 'authorkeywords Cannot be empty' }]">
                        <el-input v-model="paperform.authorkeywords" style="width:700px" type="textarea" :rows="4"
                            :autosize="{ minRows: 4, maxRows: 20 }" resize="none"></el-input>
                    </el-form-item>
                    <el-form-item label="Abstract" prop="abstractinfo"
                        :rules="[{ required: true, message: 'abstractinfo Cannot be empty' }]">
                        <el-input v-model="paperform.abstractinfo" style="width:700px" type="textarea" :rows="4"
                            resize="none" :autosize="{ minRows: 4, maxRows: 20 }"></el-input>
                    </el-form-item>
                </el-form>

            </el-col>
        </el-row>
        <el-row :gutter="10" justify="center">
            <el-col :span="24">
                <div class="authorbtn">
                    <h4 class="section">Add Author</h4>
                    <div>
                        <el-button type="primary" style="margin-left:15px" @click="add">
                            <el-icon style="margin-right:5px">
                                <plus />
                            </el-icon>
                            Add Row
                        </el-button>
                        <el-button type="danger" @click="clear">
                            <el-icon style="margin-right:5px">
                                <Delete />
                            </el-icon>
                            Delete Row
                        </el-button>
                    </div>
                </div>
                <div class="fast-emailinfo"><el-text type="primary">Click <el-icon color="#5699ffeb"
                            style="cursor: pointer;">
                            <HelpFilled />
                        </el-icon> to quickly find the key information of the email</el-text></div>
                <el-table :data="authorlist" style="width: 100%">
                    <el-table-column align="center">
                        <template #header>
                            first name <span style="color:rgba(255, 0, 0, 0.47)">*</span>
                        </template>
                        <template #default="scope">
                            <el-input v-model="authorlist[scope.$index].name1" :infoID="scope.$index"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="center">
                        <template #header>
                            last name <span style="color:rgba(255, 0, 0, 0.47)">*</span>
                        </template>
                        <template #default="scope">
                            <el-input v-model="authorlist[scope.$index].name2" :infoID="scope.$index"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="email" width="220">
                        <template #default="scope">
                            <el-input v-model="authorlist[scope.$index].email" :infoID="scope.$index">
                                <template #suffix>
                                    <el-icon color="#5699ffeb" style="cursor: pointer;"
                                        @click="fastinfo(authorlist[scope.$index])">
                                        <HelpFilled />
                                    </el-icon>
                                </template>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="center">
                        <template #header>
                            country <span style="color:rgba(255, 0, 0, 0.47)">*</span>
                        </template>
                        <template #default="scope">
                            <!-- <el-input v-model="authorlist[scope.$index].country" :infoID="scope.$index"></el-input> -->
                            <el-select v-model="authorlist[scope.$index].country" placeholder="country" filterable>
                                <el-option :value="item.label" :label="item.label" v-for="item in countryList"
                                    :key="item.id"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column align="center">
                        <template #header>
                            affiliation <span style="color:rgba(255, 0, 0, 0.47)">*</span>
                        </template>
                        <template #default="scope">
                            <el-input v-model="authorlist[scope.$index].affiliation" :infoID="scope.$index"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="Web page" align="center">
                        <template #default="scope">
                            <el-input v-model="authorlist[scope.$index].webpage" :infoID="scope.$index"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="corresponding?" align="center">
                        <template #default="scope">
                            <el-checkbox v-model="authorlist[scope.$index].corresponding"></el-checkbox>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="width:100%;display:flex;justify-content: center;margin-top:50px;margin-bottom:30px">
                    <el-button type="primary" style="width:500px" @click="submit">submit paper</el-button>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { ElMessage } from 'element-plus'
import { useRoute, useRouter } from "vue-router";
import { genFileId } from 'element-plus'
import { Document, Plus, Delete, Minus, ArrowLeftBold, HelpFilled } from '@element-plus/icons'
import request from "../../network/request"
import { saveAs } from 'file-saver';
import axios from 'axios'
import { ElLoading } from 'element-plus'


const route = useRoute()
const router = useRouter()
const myfile = ref(null)
const ruleForm = ref(null)
const fileList = ref([])
const isCover = ref(false)

//国家列表信息（下拉列表）
const countryList = ref([])
//从后端获取国家列表信息
request.get("/common/country").then((res) => {
    countryList.value = res.data
})


// 获取论文详细
function getPaperDetail() {
    request.post("/paper/detail", {
        pid: route.query.pid
    }, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
        paperform.value = res.data;
        makeFile(res.data.paperfile)
        authorlist.value = res.data.authorList;
        authorlist.value.forEach((item) => {
            item.name1 = item.firstname
            delete item.firstname;
            item.name2 = item.lastname
            delete item.lastname
            item.corresponding = item.isCorresponding == 1 ? true : false
            delete item.isCorresponding
        })
    })
}

// 构建文件信息
async function makeFile(url) {
    try {
        const loading = ElLoading.service({
            // 加载进度条
            lock: true,
            text: 'paper file loading',
            background: 'rgba(0, 0, 0, 0.7)',
        })

        // 使用 axios 获取文件内容
        const response = await axios.get(url, { responseType: 'arraybuffer' });

        // 从文件链接中获取文件名
        const fileName = url.substring(url.lastIndexOf('/') + 1);

        // 创建 Blob 对象
        const blob = new Blob([response.data], { type: 'application/pdf' });

        // 创建 Blob URL
        const blobUrl = URL.createObjectURL(blob);

        // 创建模拟的 File 对象，模拟文件信息
        const file = new File([blob], fileName, {
            type: 'application/pdf',
            lastModified: new Date().getTime(),
            size: response.data.byteLength
        });

        // 设置其他属性
        file.uid = new Date().getTime();
        file.status = 'ready';

        // 将文件添加到 fileList 中
        fileList.value.push(file);
        loading.close()
    } catch (error) {
        console.error('Error fetching file:', error);
    }
}


// 论文表单数据
const paperform = ref({
    cid: route.query.cid,
    title: '',
    authorkeywords: '',
    keyphrases: '',
    abstractinfo: '',
})

// 作者列表信息
const authorlist = ref([
    {
        name1: '',
        name2: '',
        email: '',
        country: '',
        affiliation: '',
        webpage: '',
        corresponding: false,
    }
])

// 增加作者
const add = () => {
    authorlist.value.push({
        name1: '',
        name2: '',
        email: '',
        country: '',
        affiliation: '',
        webpage: '',
        corresponding: false,
    })
}

// 清空所有作者信息
const clear = () => {
    authorlist.value.pop()
}

// 上传论文所有信息（论文、作者相应的作者）
const createpaper = (payload) => {
    const loading = ElLoading.service({
        // 加载进度条
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
    })

    let tempauthorlist = JSON.stringify(authorlist.value)
    paperform.value.authorlist = tempauthorlist
    // 论文文件对象
    paperform.value.file = payload.file
    // 修改论文
    if (route.query.modify == 1) {
        request.post("/paper/modify", paperform.value, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
            if (res.code == 200) {
                loading.close()
                ElMessage({
                    message: 'paper revision successful',
                    type: 'success',
                })
                // 判断是否是主席进行修改
                if (route.query.role) {
                    router.push(`/common/detailpaper?role=3&pid=${res.data.pid}&acronym=${route.query.acronym}&title=${route.query.title}&subnum=${route.query.subnum}`)
                }
                else {
                    router.push(`/common/detailpaper?pid=${res.data.pid}&acronym=${route.query.acronym}&title=${route.query.title}&subnum=${route.query.subnum}`)
                }

            } else {
                loading.close()
                ElMessage({
                    message: res.msg,
                    type: 'warning',
                })
            }
        })
    }
    // 提交论文
    else {
        request.post("/paper/create", paperform.value, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
            if (res.code == 200) {
                loading.close()
                ElMessage({
                    message: 'paper submission successful',
                    type: 'success',
                })
                router.push(`/common/detailpaper?pid=${res.data.pid}&acronym=${route.query.acronym}&title=${route.query.title}&subnum=${route.query.subnum}`)
            }
            else {
                loading.close()
                ElMessage({
                    message: res.msg,
                    type: 'warning',
                })
            }
        })
    }
}


// 覆盖上传文件时间
const handleExceed = (files) => {
    isCover.value = true
    myfile.value.clearFiles()
    const file = files[0]
    file.uid = genFileId()
    myfile.value.handleStart(file)
}

// 判断是否有重复值
const hasDuplicates = (array) => {
    console.log(array);
    return new Set(array).size !== array.length;
}

// 提交表单信息到后端（包括论文pdf文件）
const submit = () => {
    // 效验表单信息
    ruleForm.value.validate((valid) => {
        let isError = false
        if (valid) {
            // 判断关键词是否重复
            // 去除关键词中的空行
            paperform.value.authorkeywords = paperform.value.authorkeywords
                .split("\n")
                .filter(keyword => keyword.trim() !== '')
                .join("\n");
            if (hasDuplicates(paperform.value.authorkeywords.split("\n"))) {
                ElMessage({
                    message: 'author keywords non repeatable',
                    type: 'warning',
                })
                isError = true
                return
            }
            // 单独效验文件列表是否为空
            if (fileList.value.length == 0) {
                ElMessage({
                    message: 'the PDF file of the paper cannot be empty',
                    type: 'warning',
                })
                isError = true
                return
            }
            // 单独效验作者信息列表是否为空
            let correspondingLength = 0
            authorlist.value.forEach((item) => {
                let datalist = Object.entries(item)
                datalist.forEach((data) => {
                    console.log(data, "111");
                    // webpage不做效验
                    if (data[0] == 'webpage') {

                    }
                    // email效验是否为空
                    else if (data[0] == 'email') {
                        console.log(data[1], "222");
                        if (data[1] == null || data[1] == '') {
                            ElMessage({
                                message: `author email cannot be empty`,
                                type: 'warning',
                            })
                            isError = true
                        }
                    }
                    // corresponding不做效验
                    else if (data[0] == 'corresponding') {
                        if (data[1] == true) correspondingLength++
                    }
                    else {
                        if (data[1] == null || data[1] == '') {
                            ElMessage({
                                message: `author information exists with ${data[0]} being empty`,
                                type: 'warning',
                            })
                            isError = true
                        }
                    }
                })

            })
            // 效验作者主要联系人长度是否为0

            if (correspondingLength == 0) {
                ElMessage({
                    message: `at least one primary contact person`,
                    type: 'warning',
                })
                isError = true
            }
            // 判断作者信息是否重复
            let allEmail = []
            authorlist.value.forEach((item) => {
                if(item.email.length>1 && item.email!=null && item.email != ""){
                    allEmail.push(item.email.trim())
                }     
            })
            if (hasDuplicates(allEmail)) {
                ElMessage({
                    message: 'author information cannot be duplicated',
                    type: 'warning',
                })
                isError = true
                return
            }
            // 信息无误，提交表单
            if (!isError) {
                if (isCover.value == false && route.query.modify == 1) {
                    handleExceed(fileList.value)
                }
                myfile.value.submit()
            }
        } else {
            return false
        }
    })
}

// 快捷生成信息
const fast = () => {
    // 基础信息
    paperform.value = {
        cid: route.query.cid,
        title: 'Research on Intelligent Algorithm for Image Quality Evaluation Based on Image Distortion Type and Convolutional Neural Network',
        authorkeywords: "Image distortion type\nConvolutional neural network\nImage quality\nIntelli-gent algorithm",
        keyphrases: '',
        abstractinfo: 'In order to detect different images under different distortion conditions, this paper classifies image distortion types and proposes video image distortion detection and classification based on convolutional neural networks. By segmenting the input video image to obtain a small block image, and then using the active learning feature of the convolutional neural network, the positive and negative cases are equalized, the adaptive learning rate is slowed down and the local minimum problem is solved. The type of distortion is mainly predicted by the SoftMax classifier image, and then the video image prediction type obtained by the majority voting rule is used. The objective quality evaluation algorithm based on image distortion type and convolu-tional neural network is analyzed. Using LIVE (simulation standard image library) and actual monitoring video library, the final accurate results of the two performance tests are not much different. The overall classification ac-curacy rate is significantly higher than other algorithms. After the positive and negative case equalization and adaptive learning rate are introduced, it is found that the CNN classification accuracy can be significantly improved. The final test results also confirm that this method can actively learn image quality features, and improve the accuracy of video image classification de-tection. It is applicable to image quality detection of all video image distor-tion conditions, and has strong practicability and robustness.',
    }
    // 作者信息
    authorlist.value = [
        {
            "name1": "Runnan",
            "name2": "Li",
            "email": "2553119725@qq.com",
            "country": "China",
            "affiliation": "Guangdong University of Science and Technology",
            "webpage": "",
            "corresponding": true
        },
        {
            "name1": "Zelin",
            "name2": "Wang",
            "email": "2703566134@qq.com",
            "country": "China",
            "affiliation": "Nantong University",
            "webpage": "",
            "corresponding": false
        }
    ]
}


// 快速获取作者详细信息
const fastinfo = (row) => {
    if (row.email == '') {
        ElMessage({
            message: 'unable to recognize an empty email address',
            type: 'warning',
        })
        return
    }
    request.get(`/user/author?email=${row.email}`).then((res) => {
        if (res.code == 200) {
            ElMessage({
                message: 'successful acquisition of key information',
                type: 'success',
            })
            console.log(res.data);
            let data = res.data
            row.name1 = data.firstname
            row.name2 = data.lastname
            row.country = data.country
            row.webpage = data.webpage
            row.affiliation = data.affiliation
        } else {
            ElMessage({
                message: 'the email does not exist and cannot be retrieved',
                type: 'warning',
            })
        }
    })
}


// 首次进入页面，判断是否为修改状态，进行相应的信息修改（若为1则代表进入修改状态，先获取到原论文信息）
onMounted(() => {
    if (route.query.modify == "1") {
        getPaperDetail()
    }

})

</script>





<style lang="scss">
.createpaper-container {
    .paperinput-box {
        .el-form-item__label {
            width: 150px;
        }
    }

    .login-title {
        background: #b7dffd3b;
        margin-bottom: 50px;
        padding: 20px 0;

        .desc-box {
            font-size: 16px;
            padding: 0 30px;

            .title {
                font-weight: 700;
                font-size: 20px;
                padding: 0;
                -webkit-background-clip: text;
                background-clip: text;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                color: transparent;
            }

            .info {
                padding: 0;
                font-size: 14px;
                margin-bottom: 10px;
            }
        }
    }

    .section {
        font-weight: 700;
        font-size: 17px;
        padding: 0;
        -webkit-background-clip: text;
        background-clip: text;
        background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 41, 66));
        color: transparent;
    }

    .fast-emailinfo {
        padding-left: 14px;
        margin-bottom: 35px;
    }

    .authorbtn {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding-left: 14px;
        box-sizing: border-box;
        margin-top: 30px;

    }

    .submit {
        padding-left: 260px;
        width: 100%;

        .el-button {
            width: 300px;
        }
    }
}
</style>